import React from 'react';
import Lottie from 'react-lottie';
import cibilAnimation from './CibilScoreCheck.json'; // Adjust the path to your file

const CibilScoreAnimation = () => {
  // Configure Lottie animation options
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: cibilAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice', // Ensures the animation scales correctly
    },
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <Lottie options={defaultOptions}/>
    </div>
  );
};

export default CibilScoreAnimation;
